import { gql } from '@apollo/client'

export const UPDATE_EMAIL_MUTATION = gql`
  mutation updateEmail($input: UpdateEmailInput!) {
    updateEmail(input: $input) {
      id 
      email
      activated_at
    }
  }
`